<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :items="itens"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <datatable-filters
            :filters="filters"
            v-model="filtrosAtivos"
          ></datatable-filters>
          <v-divider vertical inset class="mx-4" />
          <v-spacer />
          <v-btn
            v-if="perms.includes('item.criar_item')"
            depressed
            color="accent"
            :to="{ name: 'item-formulario' }"
          >
            <v-icon class="mdi mdi-plus mr-2" />Novo Cadastro
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.peso_bruto="{ item }">{{
        decimal(item.peso_bruto)
      }}</template>
      <template v-slot:item.qtd_minina_estoque="{ item }">{{
        decimal(item.qtd_minina_estoque)
      }}</template>
      <template v-slot:item.qtd_maxima_estoque="{ item }">{{
        decimal(item.qtd_maxima_estoque)
      }}</template>
      <template v-slot:item.ativo="{ item }">
        <v-icon
          :class="
            item.ativo === 'S'
              ? 'mdi mdi-checkbox-marked-outline'
              : 'mdi mdi-checkbox-blank-outline'
          "
        />
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn
          v-if="perms.includes('item.editar_item')"
          icon
          small
          text
          @click="editar(item.id)"
        >
          <v-icon class="mdi mdi-pencil" small />
        </v-btn>
        <dialog-confirm
          v-if="perms.includes('item.excluir_item')"
          titulo="Deletar Item"
          texto="Confirma a exclusão?"
          @confirmar="deletar(item.id)"
        >
          <v-btn icon small text>
            <v-icon class="mdi mdi-delete" small />
          </v-btn>
        </dialog-confirm>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import DatatableFilters from "../components/DatatableFilters";
import DialogConfirm from "../components/DialogConfirm";
import { build } from "../lib/masks";
// import { build } from "../lib/masks";
export default {
  components: { DatatableFilters, DialogConfirm },
  data() {
    return {
      headers: [
        { text: "Código", value: "codigo" },
        { text: "Descrição", value: "descricao" },
        { text: "Peso Bruto", value: "peso_bruto", align: "right" },
        { text: "Estoque Mínimo", value: "qtd_minina_estoque", align: "right" },
        { text: "Estoque Máximo", value: "qtd_maxima_estoque", align: "right" },
        { text: "Ativo", value: "ativo" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      filters: [
        {
          name: "descricao",
          label: "Descrição",
          type: "text",
          defaultValue: "",
        },
        {
          name: "codigo",
          label: "Código",
          type: "text",
          defaultValue: "",
        },
      ],
      filtrosAtivos: JSON.parse(localStorage.getItem("filtros.itens") || "{}"),
      loading: false,
      dialogConfirm: false,
    };
  },
  computed: {
    itens() {
      return this.$store.state.item.Itens;
    },
    perms() {
      return this.$store.state.usuarios.usuarioAtivo.permissoes;
    },
  },
  methods: {
    async deletar(id) {
      this.loading = true;
      await this.$store.dispatch("item/deletar", { id });

      this.listar();
    },
    editar(id) {
      this.$router.replace({
        name: "item-formulario-editar",
        params: { id },
      });
    },
    async listar() {
      this.loading = true;
      try {
        await this.$store.dispatch("item/listar", this.filtrosAtivos);
      } catch (e) {
        console.log(e);
      }
      this.loading = false;
    },
    decimal(val) {
      return build.decimal3(val);
    },
  },
  watch: {
    filtrosAtivos(val) {
      localStorage.setItem("filtros.itens", JSON.stringify(val));
      this.listar();
    },
  },
  mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Cadastro de itens",
    });
    this.listar();
  },
};
</script>
